import { HugoStateApi } from "../../hugo"


export enum Entity {
    Empty = 0,
    BlockDefault = 1,
    BlockShield1 = 2,
    BlockShield2 = 3,
    BlockShield3 = 4,
    BlockRandom = 5,

    Explosion = 6,
    Ball = 7,
    Player = 8,
    Wall = 9,
    Buff = 10,
    Debuff = 11,
}

export enum Effect {
    PiercingBall = 'pB',
    BallDuplicatorPlatform = 'bdp',
}

export type Ball = {
    position: Position2D,
    velocity: Position2D,
}

export type Player = {
    position: Position2D
    width: number,
    speed: number,
}

export type Controls = {
    left: boolean,
    right: boolean,
}

export type Notification = {
    message: string,
    startTick: number,
    endTick: number,
}

export type Point = Entity

export type GameField = Point[][]

export type Level = {
    name: string,
    field: GameField
    balls: Ball[],
    player: Player,
    luck: number,
    effects: Effect[],
}

export type Position = number

export type Position2D = {
    x: Position,
    y: Position,
}

export type Rectangle = {
    x1: Position,
    x2: Position,
    y1: Position,
    y2: Position,
}


export type GameState = {
    tick: number,
    lives: number,
    isPlaying: boolean,
    currentLevel: number | null,
    field: GameField | null,
    balls: Ball[],
    player: Player | null,
    effects: Effect[],
    score: number,
    controls: Controls,
    notifications: Notification[]
    luck: number,
}

export type UseBreakoutProps = {
    hugoApi: HugoStateApi,
    tickRate?: number,
    onGameOver?: (score: number) => void,
    onWon?: (score: number) => void,
}
export type UseBreakoutReturn = [
    {
        start: (levelIndex?: number) => void,
        play: () => void,
        pause: () => void,
        stop: () => void,
        reset: () => void,
        setTick: (to: number) => void,
    },
    GameState,
]

export type UseBreakoutFn = (props: UseBreakoutProps) => UseBreakoutReturn